import { tassign } from 'tassign';
import { UpdateState, initialUpdateState } from './update-state.model';
import { Action, UpdateActions } from './update-actions';

/**
* @functions AdminReducer Will excecute the according triggered in the dispatcher
* @param state Store model
* @param action The action that will affect the store
* @return tassing<AdminReducer> Value with the store
**/
export const UpdateReducer = function (state: UpdateState = initialUpdateState, action: Action): UpdateState {
  switch (action.type) {
    case UpdateActions.SET_UPDATE:
      return tassign(state, {
        isUpdated: action.payload.isUpdated
      });
    case UpdateActions.RESET_UPDATE:
      return tassign(state, initialUpdateState);
    default:
      return state;
  }
};


